<ng-container
  *ngIf="accountArticleTranslations$ | async as accountArticleTranslations"
>
  <ng-container *ngIf="searchTranslations$ | async as searchTranslations">
    <ng-container
      *ngIf="smartPackageTranslations$ | async as smartPackageTranslations"
    >
      <div
        *ngIf="
          dangerousGoodListTranslations$
            | async as dangerousGoodListTranslations
        "
      >
        <form [formGroup]="filterFormGroup">
          <label for="filter">{{
            smartPackageTranslations['SearchButton']
          }}</label>
          <input
            id="filter"
            type="text"
            class="form-control"
            formControlName="filter"
          />
        </form>
        <div
          id="articleList"
          *ngIf="articles$ | async"
          class="table-responsive"
        >
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th scope="col">
                  {{ accountArticleTranslations['Identification'] }}
                </th>
                <th scope="col">
                  {{ searchTranslations['DangerousGoodLabels'] }}
                </th>
                <th scope="col" *ngIf="!ignoreCanBeSelectedFlag">
                  {{ searchTranslations['Actions'] }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let item of filteredArticles; trackBy: identify"
                (click)="
                  (ignoreCanBeSelectedFlag || item.CanBeSelected) &&
                    select(item)
                "
                [class.clickable]="item.CanBeSelected"
              >
                <td>
                  {{ item.Identification.MaterialNumber }}
                </td>
                <td>
                  {{ item.Identification.Name.CurrentName }}
                </td>
                <td *ngIf="!ignoreCanBeSelectedFlag">
                  <button
                    *ngIf="item.CanBeSelected"
                    type="button"
                    class="btn btn-iconed btn-iconed-primary"
                  >
                    {{ dangerousGoodListTranslations['ButtonChoose'] }}
                    <i class="btn-icon ifc-custom ifc-arrow-right"></i>
                  </button>
                  <span
                    *ngIf="!item.CanBeSelected"
                    [title]="item.SelectionError"
                    >&nbsp;<i class="ifc-custom ifc-info"></i
                  ></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
